import React from 'react';
const WarningIconV2 = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.32032 3.27464C9.02779 2.00471 10.8246 1.96503 11.5999 3.15583L11.6716 3.27464L11.6724 3.27627L18.0916 14.8681C18.7952 16.139 17.8837 17.7123 16.4193 17.7123H3.58073C2.11633 17.7123 1.20478 16.139 1.90837 14.8681L7.81413 4.20401H7.80274L8.32032 3.27464ZM10.5273 3.8028C10.2643 3.45502 9.72945 3.45393 9.46534 3.80036L9.42139 3.88174L3.00212 15.4735C2.75535 15.9193 3.07766 16.4623 3.58073 16.4623H16.4193C16.9223 16.4623 17.2447 15.9193 16.9979 15.4735L10.5794 3.88337L10.5273 3.8028ZM10.0024 13.6522L10.0667 13.6555C10.3818 13.6876 10.6274 13.9537 10.6274 14.2772C10.6273 14.6007 10.3818 14.8669 10.0667 14.899L10.0024 14.9022H9.98047C9.63546 14.9021 9.35559 14.6223 9.35547 14.2772C9.35547 13.9321 9.63539 13.6524 9.98047 13.6522H10.0024ZM9.36687 11.5624V7.84577C9.36687 7.50059 9.64669 7.22077 9.99187 7.22077C10.337 7.22088 10.6169 7.50066 10.6169 7.84577V11.5624C10.6169 11.9075 10.337 12.1873 9.99187 12.1874C9.64669 12.1874 9.36687 11.9076 9.36687 11.5624Z"
      fill="black"
    />
  </svg>
);

export default WarningIconV2;
